import { accountScopedKey } from '../features/account/accountRegistry';

// The nav's Chart item reopens the last symbol charted (DWLF-299); the market detail page records it.
// Account state, not a device preference: stored account-scoped, so sign-out clears it and another
// account on this device never inherits it.
const NOT_A_SYMBOL = new Set(['cot', 'overview']);

const keyFor = () => accountScopedKey('last-chart');

export const isChartPath = (pathname) => {
  const m = pathname.match(/^\/markets\/([^/]+)/);
  return !!m && !NOT_A_SYMBOL.has(m[1]);
};

// Stored in the app's URL form (XAU/USD → XAU-USD): a decoded route param can carry the slash.
export const rememberChart = (symbol) => {
  try { if (symbol) localStorage.setItem(keyFor(), symbol.replace('/', '-')); } catch (e) { /* private mode: Chart falls back */ }
};

export const getLastChartPath = () => {
  let symbol = null;
  try { symbol = localStorage.getItem(keyFor()); } catch (e) { /* ignore */ }
  return symbol ? `/markets/${symbol.replace('/', '-')}` : '/markets';
};
